<script lang="ts">
  import { CircleCheck } from '@lucide/svelte';
  import { fly } from 'svelte/transition';
  import { toast } from './toast.svelte';
</script>

<div
  aria-live="polite"
  class="pointer-events-none fixed inset-x-0 bottom-20 z-50 flex flex-col items-center gap-2 px-4 lg:bottom-6"
>
  {#each toast.items as item (item.id)}
    <div
      in:fly={{ y: 12, duration: 200 }}
      out:fly={{ y: 6, duration: 140 }}
      class="neu-card flex max-w-sm items-center gap-2 px-4 py-2.5 text-sm font-medium text-text shadow-raised-lg"
    >
      <CircleCheck class="size-4 shrink-0 text-success" aria-hidden="true" />
      {item.text}
    </div>
  {/each}
</div>
